import {createEvent, type Emitter, type Listener} from "react-event-hook";

export interface UserEnteredAnswerToQuestionPayload {
    taskType: string;
}

interface Event {
    useUserEnteredAnswerToQuestionListener: Listener<UserEnteredAnswerToQuestionPayload>;
    emitUserEnteredAnswerToQuestion: Emitter<UserEnteredAnswerToQuestionPayload>;
}

export const {
    useUserEnteredAnswerToQuestionListener,
    emitUserEnteredAnswerToQuestion,
} = createEvent("user-entered-answer-to-question")() as Event;
